/* eslint-disable handle-callback-err */
/**
 * WebSocket Module
 */
import SockJS from 'sockjs-client';
import Stomp from 'stomp-websocket';
import callChannelType from '@/constants/callChannelType';
import eventBus from '../../../EventBus';
import callServer from '../call/callServer';
import initNeomecca from '@/util/call/neomecca/initNeomecca';
import initKt from '@/util/call/kt/initKt';
import initKlcns from '@/util/call/klcns/initKlcns';
import initNeoWebRtc from '@/util/call/neoWebRTC/initNeoWebRtc';

const getDefaultState = () => {
  return {
    stompClient: null,
    isCallApiConnecting: false,
    isCallApiConnected: false,
    currentSubscription: null,
    callApiUserId: null
  };
};

const state = getDefaultState();

const getters = {
  IS_CALL_API_CONNECTED: (state) => {
    return state.isCallApiConnected;
  },
  callApiUserId: (state) => {
    return state.callApiUserId;
  }
};
const mutations = {
  START_CALL_API_CONNECT(state) {
    state.isCallApiConnecting = true;
  },
  END_CALL_API_CONNECT(state) {
    state.isCallApiConnecting = false;
    state.isCallApiConnected = true;
    state.stompClient.connected = true;
    return true;
  },
  FAIL_CALL_API_CONNECT(state) {
    state.isCallApiConnecting = false;
    state.isCallApiConnected = false;
    state.stompClient.connected = false;
  },
  callApiSubScribe(state, payload) {
    state.isCallApiConnecting = false;
    let subscription = (state.currentSubscription = state.stompClient.subscribe(
      payload.subscribeUrl,
      (tick) => payload.callBack(JSON.parse(tick.body)),
      {}
    ));

    state.subscription = {
      subscriptionUrl: payload.subscribeUrl,
      id: subscription.id,
      subscription: subscription
    };
  },
  forceCallApiCloseSubscription(state) {
    if (state.subscription) {
      state.subscription.subscription.unsubscribe();
    } else {
      console.log('연결되어있는 콜 API 소켓이 없습니다.');
    }
  },
  changeCallApiUserId(state, userId) {
    state.callApiUserId = userId;
  }
};

const actions = {
  async call_api_connect({ commit, state, rootGetters }) {
    const { isKtOrKlcns } = rootGetters;
    if (state.isCallApiConnected || (state.isCallApiConnecting && !state.isCallApiConnected) || (!isKtOrKlcns && !callServer.state.callApiUrl)) {
      return false;
    }

    const callSocketUrl = isKtOrKlcns ? `${process.env.BASE_URL}/api/webSocket` : `${callServer.state.callApiUrl}/api/call/webSocket`;
    commit('START_CALL_API_CONNECT');
    state.stompClient = Stomp.over(new SockJS(callSocketUrl, null, { transports: 'websocket', timeout: 1000 }));
    if (process.env.NODE_ENV === 'production') {
      state.stompClient.debug = null;
    }
    state.stompClient.connect(
      {},
      (frame) => {
        commit('END_CALL_API_CONNECT');
        eventBus.$emit('call-api-socket-connection-success');

        const { callMode } = rootGetters;
        switch (callMode) {
          case callChannelType.NEOMECCA:
            initNeomecca.resetCount('api');
            break;
          case callChannelType.KT:
            initKt.resetCount('api');
            break;
          case callChannelType.KLCNS:
            initKlcns.resetCount('api');
            break;
          case callChannelType.NEO_WEB_RTC:
            initNeoWebRtc.resetCount('api');
            break;
        }

        return true;
      },
      (error) => {
        commit('forceCallApiCloseSubscription');
        commit('FAIL_CALL_API_CONNECT');
        eventBus.$emit('call-api-reconnect-start');
      }
    );
  },
  closeCallApiConnect({ state, commit }) {
    if (!state.stompClient) return;
    if (state.stompClient.connected === false) return;
    commit('FAIL_CALL_API_CONNECT');
    state.stompClient.disconnect();
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/callApiWebsocket/index.js